<div class="container min-h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Instellingen</h2>
  </div>

  <form class="flex flex-col gap-12" [formGroup]="form">
    <div class="grid lg:grid-cols-3 gap-4">
      <div>
        <div class="font-medium">Algemeen</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          Algemene instellingen voor deze cliënt.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="grid grid-cols-6 gap-4 max-w-2xl">
            <div class="col-span-full lg:col-span-4">
              <div class="space-y-2">
                <label for="client" class="block font-medium text-sm select-none"
                  >Naam cliënt</label
                >

                <mat-form-field class="w-full">
                  <input
                    matInput
                    formControlName="name"
                    autocomplete="off"
                    enterkeyhint="next"
                    id="client"
                    type="text"
                  />

                  @if (controls.name.hasError('required')) {
                    <mat-error>Dit veld is verplicht</mat-error>
                  } @else if (controls.name.hasError('maxlength')) {
                    <mat-error
                      >Max.
                      {{ controls.name.getError('maxlength').requiredLength }}
                      karakters</mat-error
                    >
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-span-full lg:col-span-4">
              <div class="space-y-2">
                <label for="nickname" class="block font-medium text-sm select-none"
                  >Roepnaam</label
                >
                <div class="text-gray-700 text-pretty text-sm">
                  De roepnaam wordt gebruikt als tekstvariabele in interacties
                </div>

                <mat-form-field class="w-full">
                  <input
                    matInput
                    formControlName="nickname"
                    autocomplete="off"
                    enterkeyhint="next"
                    id="nickname"
                    type="text"
                  />

                  @if (controls.nickname.hasError('required')) {
                    <mat-error>Dit veld is verplicht</mat-error>
                  } @else if (controls.nickname.hasError('maxlength')) {
                    <mat-error
                      >Max.
                      {{ controls.nickname.getError('maxlength').requiredLength }}
                      karakters</mat-error
                    >
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid lg:grid-cols-3 gap-4" formGroupName="config">
      <div>
        <div class="font-medium">Apparaat</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          Specifieke apparaat instellingen voor deze cliënt.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="grid grid-cols-6 gap-4 max-w-2xl">
            <div class="col-span-full lg:col-span-3">
              <div class="space-y-2">
                <label
                  for="wait-for-answer"
                  class="block font-medium text-sm select-none"
                  >Wachttijd op antwoord</label
                >

                <mat-form-field class="w-full">
                  <input
                    matInput
                    formControlName="waitForAnswer"
                    autocomplete="off"
                    enterkeyhint="next"
                    id="wait-for-answer"
                    step="1"
                    min="2"
                    max="5"
                    type="number"
                  />

                  <span matSuffix class="text-sm pl-2 pr-4">min</span>

                  @if (
                    configControls.waitForAnswer.hasError('required') ||
                    configControls.waitForAnswer.hasError('pattern')
                  ) {
                    <mat-error>Vul alleen gehele getallen in</mat-error>
                  } @else if (configControls.waitForAnswer.hasError('min')) {
                    <mat-error
                      >Minimale waarde is
                      {{ configControls.waitForAnswer.getError('min').min }}</mat-error
                    >
                  } @else if (configControls.waitForAnswer.hasError('max')) {
                    <mat-error
                      >Maximale waarde is
                      {{ configControls.waitForAnswer.getError('max').max }}</mat-error
                    >
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-span-full">
              <div class="flex items-center mb-4">
                <div class="space-y-2 flex-auto pr-4">
                  <div class="block font-medium text-sm select-none">
                    Vooraankondiging
                  </div>
                  <div class="text-gray-700 text-pretty text-sm">
                    Indien ingeschakeld, speel een geluid af voordat een interactie
                    begint
                  </div>
                </div>

                <mat-slide-toggle hideIcon formControlName="notify" />
              </div>

              @if (configControls.notify.value) {
                <div class="space-y-2">
                  <label for="client" class="block font-medium text-sm select-none"
                    >Selecteer een geluid</label
                  >
                  <div
                    class="max-h-60 py-2 pl-2 pr-4 overscroll-contain overflow-y-auto rounded-sm border border-(--mat-sys-outline) hover:border-(--mat-sys-on-surface)"
                  >
                    <mat-radio-group
                      formControlName="notifySoundId"
                      class="flex flex-col gap-1"
                    >
                      @for (sound of sounds(); track sound._id) {
                        <div class="flex items-center">
                          <mat-radio-button [value]="sound._id" class="flex-auto h-10">
                            {{ sound.label }}
                            @if (sound.isDefault) {
                              <span class="text-xs text-gray-500 ml-1"
                                >(standaard)</span
                              >
                            }
                          </mat-radio-button>
                          <button
                            mat-icon-button
                            type="button"
                            (click)="playSound(sound)"
                            class="shrink-0 inline-flex!"
                          >
                            <mat-icon>{{
                              playingSoundId() === sound._id ? 'stop' : 'play_arrow'
                            }}</mat-icon>
                          </button>
                        </div>
                      } @empty {
                        <div class="text-sm text-gray-500">
                          Geen geluiden beschikbaar
                        </div>
                      }
                    </mat-radio-group>
                  </div>
                </div>
              }
            </div>

            <div class="col-span-full">
              <div class="space-y-2 flex flex-col">
                <label for="volume" class="flex font-medium text-sm select-none"
                  >Volume

                  <span class="ml-auto font-normal">{{ slider.value }}%</span>
                </label>

                <mat-slider
                  [min]="0"
                  [max]="100"
                  [step]="5"
                  class="flex-auto [--mdc-slider-inactive-track-color:var(--color-gray-400)]"
                >
                  <input matSliderThumb formControlName="volume" id="volume" #slider />
                </mat-slider>
              </div>
            </div>

            <div class="col-span-full">
              <div class="flex items-center">
                <div class="space-y-2 flex-auto pr-4">
                  <div class="block font-medium text-sm select-none">
                    Volume bediening op scherm
                  </div>
                  <div class="text-gray-700 text-pretty text-sm">
                    Sta toe dat het volume aangepast kan worden via het robotscherm
                  </div>
                </div>

                <mat-slide-toggle hideIcon formControlName="allowVolumeControl" />
              </div>
            </div>

            <div class="col-span-full">
              <div class="flex items-center">
                <div class="space-y-2 flex-auto pr-4">
                  <div class="block font-medium text-sm select-none">
                    Batterijniveau aankondigen
                  </div>
                  <div class="text-gray-700 text-pretty text-sm">
                    Kondig het batterijniveau aan via spraak wanneer het niveau 20% of
                    lager is
                  </div>
                </div>

                <mat-slide-toggle hideIcon formControlName="announceBatteryLevel" />
              </div>
            </div>

            <div class="col-span-full">
              <div class="space-y-3">
                <div>
                  <div class="block font-medium text-sm select-none">
                    Prioriteit interacties
                  </div>
                  <div class="text-gray-700 text-pretty text-sm mt-1">
                    Wat moet de robot doen als een agenda-item wordt uitgevoerd terwijl
                    iets speelt?
                  </div>
                </div>

                <mat-radio-group formControlName="interactionPriority" class="flex flex-col gap-2">
                  <div class="flex items-start gap-3">
                    <mat-radio-button value="scm" class="mt-0.5"></mat-radio-button>
                    <div class="flex-1">
                      <div class="font-medium text-sm">Afmaken wat speelt</div>
                      <div class="text-gray-700 text-pretty text-xs">
                        Wacht totdat wat momenteel speelt is afgelopen, en voer het
                        agenda-item daarna uit.
                      </div>
                    </div>
                  </div>

                  <div class="flex items-start gap-3">
                    <mat-radio-button value="scheduler" class="mt-0.5"></mat-radio-button>
                    <div class="flex-1">
                      <div class="font-medium text-sm">Agenda-item uitvoeren</div>
                      <div class="text-gray-700 text-pretty text-xs">
                        Stop wat momenteel speelt en voer het agenda-item onmiddellijk uit.
                        Het wordt niet gemist.
                      </div>
                    </div>
                  </div>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Speech settings -->
    <div class="grid lg:grid-cols-3 gap-4" formGroupName="config">
      <div>
        <div class="font-medium">Spraak</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          Kies de taal en stem voor gesproken inhoud.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="grid grid-cols-6 gap-4 max-w-2xl">
            <div class="col-span-full lg:col-span-4 space-y-1">
              <label
                for="tts-lang"
                class="block font-medium text-sm select-none"
                >Taal</label
              >
              <mat-form-field class="w-full">
                <mat-select formControlName="ttsLang" id="tts-lang">
                  @for (lang of voiceCatalog; track lang.lang) {
                    <mat-option [value]="lang.lang">
                      {{ lang.label }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-span-full lg:col-span-4 space-y-1">
              <label
                for="tts-voice"
                class="block font-medium text-sm select-none"
                >Stem</label
              >
              <div class="text-gray-700 text-pretty text-sm">
                Beschikbare stemmen zijn afhankelijk van de geselecteerde taal
              </div>
              <mat-form-field class="w-full">
                <mat-select formControlName="ttsVoice" id="tts-voice">
                  <mat-optgroup label="Vrouw">
                    @for (voice of femaleVoices(); track voice.value) {
                      <mat-option [value]="voice.value">
                        {{ voice.label }}
                      </mat-option>
                    }
                  </mat-optgroup>
                  <mat-optgroup label="Man">
                    @for (voice of maleVoices(); track voice.value) {
                      <mat-option [value]="voice.value">
                        {{ voice.label }}
                      </mat-option>
                    }
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-span-full">
              <button
                mat-stroked-button
                type="button"
                (click)="previewVoice()"
              >
                <mat-icon>{{
                  isVoicePreviewing() ? 'stop' : 'play_arrow'
                }}</mat-icon>
                {{ isVoicePreviewing() ? 'Stoppen' : 'Voorbeeld' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Face appearance -->
    <div class="grid lg:grid-cols-3 gap-4" formGroupName="config">
      <div>
        <div class="font-medium">Gezicht</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          Kies het uiterlijk van het robotgezicht. Herstart de robot om de
          wijziging toe te passen.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8 space-y-8">
          <!-- Face variant picker -->
          <div class="space-y-3">
            <div class="font-medium text-sm">Variant</div>
            <div class="face-variant-grid">
              @for (variant of faceVariants; track variant.value) {
                <button
                  type="button"
                  class="face-variant-card"
                  [class.face-variant-card--selected]="
                    configControls.faceVariant.value === variant.value
                  "
                  (click)="configControls.faceVariant.setValue(variant.value)"
                  [id]="'face-variant-' + variant.value"
                >
                  <div class="face-variant-card__preview">
                    <mat-icon class="face-variant-card__icon">face</mat-icon>
                    <img
                      class="face-variant-card__img"
                      [src]="variant.previewUrl"
                      [alt]="variant.label"
                      (load)="$any($event.target).classList.add('loaded')"
                    />
                  </div>
                  <div class="face-variant-card__label">{{ variant.label }}</div>
                </button>
              }
            </div>
          </div>

          <!-- Color picker -->
          <div class="space-y-3">
            <div class="font-medium text-sm">Kleur</div>
            <div class="face-color-grid">
              @for (color of faceColors; track color.value) {
                <button
                  type="button"
                  class="face-color-swatch"
                  [class.face-color-swatch--selected]="
                    configControls.faceColor.value === color.value
                  "
                  [style.--swatch-color]="color.hex"
                  (click)="configControls.faceColor.setValue(color.value)"
                  [id]="'face-color-' + color.value"
                  [title]="color.label"
                >
                  <span class="face-color-swatch__dot"></span>
                  <span class="face-color-swatch__label">{{ color.label }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <audio #audioPlayer hidden></audio>

    @if (clientVars().length > 0) {
      <div class="grid lg:grid-cols-3 gap-4">
        <div>
          <div class="font-medium">Variabelen</div>
          <div class="text-sm text-pretty text-gray-700 mt-1">
            Cliënt specifieke variabelen die je kunt gebruiken in interacties.
          </div>
        </div>
        <div class="col-span-2 bg-white rounded-lg">
          <div class="p-8">
            <div class="max-w-2xl">
              <div
                class="bg-blue-100 border border-blue-200 text-blue-900 text-xs p-4 mb-4 rounded-lg"
              >
                <div class="flex gap-2">
                  <mat-icon class="shrink-0">info</mat-icon>

                  <span class="[text-box-trim:trim-both] leading-5 text-pretty"
                    >Variabelen hebben een standaardwaarde die voor alle cliënten geldt.
                    Je kunt per cliënt een
                    <code
                      class="text-blue-700 font-bold bg-blue-200 px-1 py-0.5 rounded-sm"
                      >overschrijving</code
                    >
                    instellen om een andere waarde te gebruiken. Laat het veld leeg om
                    de standaardwaarde te gebruiken.</span
                  >
                </div>
              </div>

              <table class="w-full text-sm">
                <thead>
                  <tr
                    class="border-b border-gray-200 text-left text-gray-500 text-xs uppercase tracking-wider"
                  >
                    <th class="pb-2 pr-4 font-medium">Sleutel</th>
                    <th class="pb-2 pr-4 font-medium">Standaardwaarde</th>
                    <th class="pb-2 font-medium">Overschrijving</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of clientVars(); track v.baseVarId) {
                    <tr class="border-b border-gray-100">
                      <td class="py-3 pr-4 font-mono text-xs break-all">
                        <code class="bg-gray-100 px-1.5 py-0.5 rounded-sm text-gray-800"
                          >[{{ v.key }}]</code
                        >
                      </td>
                      <td class="py-3 pr-4 text-gray-500 break-all">
                        {{ v.baseValue }}
                      </td>
                      <td class="py-3">
                        <mat-form-field
                          subscriptSizing="dynamic"
                          class="w-full [--mdc-filled-text-field-container-color:transparent]"
                        >
                          <input
                            matInput
                            [value]="v.isOverridden ? v.value : ''"
                            (input)="onVarOverrideChange(v.baseVarId, $any($event.target).value)"
                            [disabled]="!canEditVars() || submitted()"
                            [placeholder]="v.baseValue"
                            autocomplete="off"
                            type="text"
                          />
                        </mat-form-field>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }

    <div *appHasPermission="'client:update'" class="flex justify-end">
      <button
        mat-flat-button
        type="submit"
        [disabled]="form.invalid || submitted()"
        (click)="handleSubmit()"
      >
        Opslaan
      </button>
    </div>
  </form>
</div>
